"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lazyload = require("../utils/lazyload");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var iframeStyle = {
  position: 'absolute',
  left: 0,
  width: 0,
  height: '100%',
  border: 0
};

var Expand =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Expand, _PureComponent);

  function Expand(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.bindIframe = _this.bindIframe.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.setHeight = _this.setHeight.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Expand.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setHeight();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.props.setExpandHeight(0);
  };

  _proto.setHeight = function setHeight() {
    if (this.element) {
      this.props.setExpandHeight(this.element.clientHeight);
    }
  };

  _proto.bindElement = function bindElement(el) {
    this.element = el;
  };

  _proto.bindIframe = function bindIframe(el) {
    if (el && el.contentWindow) {
      el.contentWindow.onresize = (0, _lazyload.throttleWrapper)(this.setHeight);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        colSpan = _this$props.colSpan,
        children = _this$props.children;
    return _react.default.createElement("tr", {
      ref: this.bindElement
    }, _react.default.createElement("td", {
      style: {
        padding: 0
      },
      colSpan: colSpan
    }, _react.default.createElement("iframe", {
      title: "scroll",
      ref: this.bindIframe,
      style: iframeStyle
    }), children));
  };

  return Expand;
}(_react.PureComponent);

Expand.propTypes = {
  children: _propTypes.default.any,
  colSpan: _propTypes.default.number,
  setExpandHeight: _propTypes.default.func
};
var _default = Expand;
exports.default = _default;